module.exports = __webpack_public_path__ + "static/media/default-banner.44a5dcea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/default-banner.jpg
// module id = 798
// module chunks = 0